import { DatePipe } from '@angular/common';
import { Directive, AfterViewInit, Input, OnChanges, SimpleChanges, ElementRef } from '@angular/core';
import { GasDatePipe } from '../gas-date-pipe/gas-date.pipe';
import { DateFormat } from './date-format.type';

/**
 * Данная директива корректирует визуальное отображение выбранной даты из датапикера
 *
 * @param gasDate - выбранная дата
 * @param format - формат для отображения даты
 *
 * @example
 *  <gas-input
      gasDatepicker
      [gasDate]="dateControl?.value"
      format="dd.MM.yyyy HH:mm:ss"
      [formControl]="dateControl"
    >
    </gas-input>
 */
@Directive({
  selector: '[gasDate]',
  providers: [GasDatePipe, DatePipe],
})
export class GasDateDirective implements AfterViewInit, OnChanges {
  @Input()
  public gasDate: Date | string;

  @Input()
  public format: DateFormat = 'dd.MM.yyyy';

  public input: HTMLInputElement;

  constructor(
    private elementRef: ElementRef,
    private gasDatePipe: GasDatePipe,
  ) {}

  public ngAfterViewInit(): void {
    this.input = this.elementRef.nativeElement.querySelector('input');

    if (this.gasDate) {
      this.setValue();
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.gasDate?.currentValue) {
      this.setValue();
    }
  }

  private setValue(): void {
    if (!this.input) {
      return;
    }

    const date = this.gasDatePipe.transform(this.gasDate, this.format);

    /**
     * проверяем что отформатированная дата соответствует формату
     * это нужно что бы не ломался ввод даты с клавиатуры
     */
    if (date.length === this.format.length) {
      this.input.value = date;
    }
  }
}
